module.exports = __webpack_public_path__ + "static/media/purepapermetal-skin-bronze-brushed-4045-panel.ea0f05f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapermetal-skin-bronze-brushed-4045-panel.jpg
// module id = 1114
// module chunks = 37